import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {DasUBoot} from "../DasUBoot";
import {gsap} from "gsap";
import {SymbolUtils} from "../utils/SymbolUtils";
import {DasUBootSymbol, DasUBootSymbolStates} from "../reels/DasUBootSymbol";
import {SimpleReelModelSymbolData} from "../../core/reel/simplereel/SimpleReelModel";
import {isMysterySymbol} from "../reels/symbols/MysterySymbol";
import {DasUBootRoundType} from "../server/DasUBootData";
import {MiniLampState} from "../view/parts/SpineLamp";
import {DasUBootGameMode} from "../server/DasUBootGameMode";
import {DasUBootSound} from "../sound/DasUBootSound";

/**
 * Created by jonas on 2021-03-10.
 */

export class TorpedoLaunch implements SimplePresentation {

    start(controller:SimplePresentationRunnerController):void {
        const tl:gsap.core.Timeline = gsap.timeline({onComplete:() => controller.finish(), paused:true});
        tl.add(() => controller.setSkipCallback(() => tl.seek("end", false)));


        const torpedoSymbols:SimpleReelModelSymbolData[] = DasUBoot.reelView.reelFrame.torpedoView.stickySymbols;
        DasUBoot.reelView.reelFrame.torpedoView.commitStickySymbolsToReel(false);

        const revealAnimations = [];
        const resizeTl = gsap.timeline();
        let initialDelay = 0.2;
        for (let data of DasUBoot.model.clientData.torpedoParts) {
            if (data == undefined || data.firedThisSpin == undefined) {
                throw new Error("torpedo data is missing");
            }

            let xWayIndex = 0;

            const xWayCount = TorpedoLaunch.getSymbolCount(data.reel) + data.size;
            const symbolScale = DasUBoot.model.gameData.gameAreaSize[data.reel] / xWayCount;
            const reelTl = gsap.timeline();
            let partSize = 144 * symbolScale;

            const symbolDatas = DasUBoot.reelView.reels[data.reel].model.getAllVisibleSymbols();
            symbolDatas.push(torpedoSymbols[data.reel - 1]);

            for (let i:number = 0; i < symbolDatas.length; i++) {
                const symbolData = symbolDatas[i];
                const symbol = <DasUBootSymbol>symbolData.positionable;

                let offset = (partSize * xWayIndex) - 144 * i;

                if (isMysterySymbol(symbol)) {
                    if (symbol.subSymbols != undefined) {
                        reelTl.add([
                            symbol.getStateAnimation(DasUBootSymbolStates.UN_STICK),
                            symbol.resize(symbolScale * symbol.subSymbols.length, offset, 0.5)
                        ], 0);
                        xWayIndex += symbol.subSymbols.length;
                    } else {
                        const reel = data.reel;
                        if (!symbol.isRevealed) {
                            symbol.addSubSymbols(SymbolUtils.createSubSymbols(data.reel, data.size, data.firedThisSpin.symbol));
                        }
                        reelTl.add([
                            () => DasUBoot.reelView.reelFrame.switchMiniLamps(MiniLampState.OFF, [reel]),
                            symbol.getStateAnimation(DasUBootSymbolStates.UN_STICK),
                            symbol.resize(symbolScale * data.size, offset, 0.5)
                        ], 0);

                        revealAnimations.push(symbol.getStateAnimation(DasUBootSymbolStates.REVEAL));
                        xWayIndex += data.size;
                    }
                } else {
                    reelTl.add(symbol.resize(symbolScale, offset, 0.5), 0);
                    xWayIndex++;
                }
            }

            resizeTl.add(reelTl, `<${initialDelay}`);
            initialDelay -= 0.02;
        }

        tl.add(DasUBoot.reelView.reelFrame.animateXLamps(false));
        tl.add(DasUBoot.reelView.reelFrame.torpedoView.launchTorpedo(2.0));
        tl.add(resizeTl, "<0.8");
        tl.add(()=>DasUBoot.soundPlayer.playSound(DasUBootSound.TORPEDO_SYMBOLS_REVEAL));
        tl.add(revealAnimations);


        tl.addLabel("end");

        tl.play();

    }

    private static getSymbolCount(reel:number) {
        if (reel == 2 || reel == 3) {
            return 4;
        }

        if (reel == 1 && DasUBoot.model.gameData.mystery && DasUBoot.model.gameData.mystery.positions[0] >= 0) {
            return 2 + DasUBoot.model.gameData.mystery.size;
        }

        if (reel == 4 && DasUBoot.model.gameData.mystery && DasUBoot.model.gameData.mystery.positions[1] >= 0) {
            return 2 + DasUBoot.model.gameData.mystery.size;
        }

        return 3;
    }

    shouldRun():boolean {
        return DasUBoot.model.data.roundType == DasUBootRoundType.SUPER_FREE_SPIN &&
            DasUBoot.model.data.nextMode != DasUBootGameMode.AVALANCHE &&
            !!DasUBoot.model.gameData.torpedo?.isComplete;
    }


}